import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";

export const GET_FAQ_BY_ID = gql`
  query FaqCategory($id: Int!) {
    faqCategoryByID(id: $id) {
      categoryName
      subcategories {
        position
        subCategoryName
        questions {
          question
          answer
          position
        }
      }
    }
  }
`;
